import type { MailboxInfo } from "owa-client-types";
import { isMyOutlookProductEnabled } from "./isMyOutlookProductEnabled";

/** @deprecated Legacy MyOutlook hint; now mirrors the Today product gate until callers are removed. */
export function hasOnboardingCompletionHint(mailboxInfo: MailboxInfo): boolean {
    return isMyOutlookProductEnabled(mailboxInfo);
}
